import { Box, FormControl, MenuItem, TextField } from '@mui/material'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { useIDPContext } from '@copyrightdelta/drx-frontend-api';
import { setProfileIdInHeader } from '../api/base';
import { ProfileContext } from '../context/profileContext';

const ProfileSelect = () => {
    const { switchProfile, selectedProfile, profiles: idpProfiles } = useIDPContext()
    const { profiles: reconciledProfiles, selectedProfileId, ready } = useContext(ProfileContext)

    // Once App has reconciled against the IDP, that list is the truth. The IDP
    // context's own `profiles` is a localStorage snapshot that survives refreshes
    // unchecked, so it can offer a profile the user no longer has — picking it
    // would just earn a rejection from the backend. Fall back to it only until
    // the first reconcile lands (or if the IDP could not be reached).
    const profiles = ready ? reconciledProfiles : idpProfiles
    const value = (ready ? selectedProfileId : selectedProfile) ?? ''

    const handleProfileChange = async (event) => {
        localStorage.setItem('selectedProfileId', event.target.value)
        await switchProfile(event.target.value)
        // navigate to home page
        setProfileIdInHeader()
        // navigate to home page
        window.location.href = '/'
    }

    const { t } = useTranslation();

    if (profiles?.length === 0 || !profiles) return null

    return (
        <Box>
            <FormControl>
                <TextField
                    select
                    id="profile"
                    value={value}
                    label={t("select_profile")}
                    onChange={(e) => handleProfileChange(e)}
                >
                    {profiles?.map((profile) => (
                        <MenuItem key={profile?.profile_id} value={profile.profile_id}>
                            {profile?.display_name}
                        </MenuItem>
                    ))}
                </TextField>
            </FormControl>
        </Box>
    )
}

export default ProfileSelect
